import { render, staticRenderFns } from "./SelectEstaticos.vue?vue&type=template&id=5310e607"
import script from "./SelectEstaticos.vue?vue&type=script&lang=js"
export * from "./SelectEstaticos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports